export const strict = false;
export const type = 'demos';

export const GET = 'GET';
export const DEMO = 'DEMO';
export const GET_ALL = 'GET_ALL';
export const CREATE = 'CREATE';
export const RESCHEDULE = 'RESCHEDULE';

const SET_DEMO = 'SET_DEMO';

export const state = () => ({
  data: {}
});

export const actions = {
  async [GET]({
    commit
  }, { token }) {
    const response = await this.$axios.$get(
      `api/v1/demos/${token}`
    );

    commit(SET_DEMO, response);
  },
  [CREATE]({ getters, state, commit }, {
    date,
    eventTypeSlug,
    demoTemplateRoutingOwnerSlug,
    demoTemplateRoutingSlug,
    timeZone,
    time,
    slug,
    userId,
    form,
    teamMembersIds,
    l2aoMatchedUserId
  }) {
    const options = Object.fromEntries(new URLSearchParams(window.location.search));

    const data = {
      time_zone: timeZone,
      appointment: {
        user_id: userId,
        owner: slug,
        slug: eventTypeSlug,
        demo_template_routing_owner_slug: demoTemplateRoutingOwnerSlug,
        demo_template_routing_slug: demoTemplateRoutingSlug,
        demo_date: `${date}T${time}`,
        answers: form,
        additional_guests: form.guests,
        teamMembersIds: teamMembersIds
      },
      iframe: options.iframe,
      l2ao_matched_user_id: l2aoMatchedUserId
    };

    return this.$axios.$post(
      `api/v1/book/${slug}/${eventTypeSlug}`,
      data
    );
  },
  [RESCHEDULE]({ getters, state, commit }, {
    date, timeZone, time, reschedule
  }) {
    const data = {
      time_zone: timeZone,
      reschedule,
      demo_date: `${date}T${time}`
    };

    return this.$axios.$patch(
      `api/v1/appointments/reschedule`,
      data
    );
  }
};

export const mutations = {
  [SET_DEMO](state, { data }) {
    state.data = data;
  }
};

export const getters = {
  [DEMO](state, getters) {
    return state.data.attributes
      ? { ...state.data.attributes, id: state.data.id }
      : null;
  }
};
